import type { JobType, ProjectKind } from '../types/api';

export const AGENT_OPTIONS: { type: JobType; label: string; description: string; kind?: ProjectKind }[] = [
  { type: 'CONTENT', label: 'Create posts', description: 'Turn topics into blog posts, ready for review.', kind: 'CONTENT' },
  { type: 'RESEARCH', label: 'Find leads', description: 'Research new leads using a lead type’s brief.', kind: 'OUTREACH' },
  { type: 'OUTREACH', label: 'Write emails', description: 'Choose leads and draft a personalized email for each.', kind: 'OUTREACH' },
  { type: 'ENRICH', label: 'Enrich leads', description: 'Research missing details for existing leads.', kind: 'OUTREACH' },
  { type: 'CUSTOM', label: 'Custom task', description: 'Give an agent a specific brief and expected outcome.' },
];

export const agentOptionsFor = (kind: ProjectKind) => AGENT_OPTIONS.filter((option) => !option.kind || option.kind === kind);

export const agentRunPrompt = (projectId: string, type?: JobType) =>
  `Use the RentX MCP server to run ${type ? `pending ${type}` : 'all pending'} jobs for project ${projectId}. ` +
  `Call claim_job with projectId "${projectId}"${type ? ` and types ["${type}"]` : ''}, using a unique workerId. ` +
  'Follow each job’s instructions, heartbeat while working, and complete or fail each job. ' +
  'Keep claiming matching jobs until the queue is empty. Leave drafts that require approval for review in the dashboard.';
